<template>
  <div class="fg-box football-details" v-if="current_match.status == -2">
    <div class="football-top-section">
      <div class="teams">
        <div class="team team-a">{{ h_team.name }}</div>
        <div class="scores">
          <div class="score">
            <span>{{ h_team.score || 0 }} - {{ a_team.score || 0 }}</span>
          </div>
          <!-- <div class="time">{{ matchTime }}</div> -->
        </div>
        <div class="team team-b">{{ a_team.name }}</div>
      </div>
      <div class="players" v-if="allGoals && allGoals.length">
        <div class="player player-a">
          <div
            v-for="mg in matchGoals(false)"
            :key="mg.player_id"
          >
            <span class="goal_scorer">{{mg.display_name}} </span>
            <span class="goal_details">{{mg.goal_details}}</span>
          </div>
        </div>
        <div class="football-icon"></div>
        <div class="player player-b">
          <div
            v-for="mg in matchGoals(true)"
            :key="mg.player_id"
          >
            <span class="goal_scorer">{{mg.display_name}} </span>
            <span class="goal_details">{{mg.goal_details}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="football-bottom-section">
      <div
        v-for="(evt, evt_idx) in events"
        :key="evt_idx"
        :class="`evt_${evt.event_id}`"
      >
        <!-- Goal -->
        <div
          v-if="isGoal(evt.event_id) && isAwayTeamEvent(evt.team_id)"
          class="event-strip team_b_event"
        >
          <div class="player player-lt" />
          <div class="score">
            <span>{{ getMinuteBubble(evt.time) }}</span>
          </div>
          <div class="player player-rt">
            <span>{{ evt.offensive_player.display_name }}</span>
            <span v-if="evt.score && evt.score.length">
              (<span>{{ evt.score[0] }}</span> - <span>{{ evt.score[1] }}</span
              >)
            </span>
            <div class="assist-by" v-if="evt.event_id == ownGoal">Own goal</div>
            <div class="assist-by" v-else-if="evt.event_id == penaltyGoal">Penalty</div>
            <div class="assist-by" v-else-if="evt.assisting_player">Assist by {{ evt.assisting_player.player_name }}</div>
            <span :class="['icon football', {'red': (evt.event_id == ownGoal)}, {'green': (evt.event_id != ownGoal)}]"></span>
          </div>
        </div>
        <div
          v-else-if="isGoal(evt.event_id) && !isAwayTeamEvent(evt.team_id)"
          class="event-strip team_a_event"
        >
          <div class="player player-lt">
            <span>{{ evt.offensive_player.display_name }}</span>
            <span v-if="evt.score && evt.score.length">
              (<span>{{ evt.score[0] }}</span> - <span>{{ evt.score[1] }}</span
              >)
            </span>
            <div class="assist-by" v-if="evt.event_id == ownGoal">Own goal</div>
            <div class="assist-by" v-else-if="evt.event_id == penaltyGoal">Penalty</div>
            <div class="assist-by" v-else-if="evt.assisting_player">Assist by {{ evt.assisting_player.player_name }}</div>
            <span :class="['icon football', {'red': (evt.event_id == ownGoal)}, {'green': (evt.event_id != ownGoal)}]"></span>
          </div>
          <div class="score">
            <span>{{ getMinuteBubble(evt.time) }}</span>
          </div>
          <div class="player player-rt" />
        </div>

        <!-- Substitute -->
        <div
          v-if="isSubstitute(evt.event_id) && isAwayTeamEvent(evt.team_id)"
          class="event-strip team_b_event"
        >
          <div class="player player-lt" />
          <div class="score">
            <span>{{ getMinuteBubble(evt.time) }}</span>
          </div>
          <div class="player player-rt green">
            <span>{{ evt.substitution.player_in.player_name }}</span>
            <div class="assist-by red">
              {{ evt.substitution.player_out.player_name }}
            </div>
            <span class="icon arrows"></span>
          </div>
        </div>
        <div
          v-else-if="isSubstitute(evt.event_id) && !isAwayTeamEvent(evt.team_id)"
          class="event-strip team_a_event"
        >
          <div class="player player-lt green">
            <span>{{ evt.substitution.player_in.player_name }}</span>
            <div class="assist-by red">
              {{ evt.substitution.player_out.player_name }}
            </div>
            <span class="icon arrows"></span>
          </div>
          <div class="score">
            <span>{{ getMinuteBubble(evt.time) }}</span>
          </div>
          <div class="player player-rt" />
        </div>

        <!-- Cards -->
        <div
          v-if="isCard(evt.event_id) && isAwayTeamEvent(evt.team_id)"
          class="event-strip team_b_event"
        >
          <div class="player player-lt" />
          <div class="score">
            <span>{{ getMinuteBubble(evt.time) }}</span>
          </div>
          <div class="player player-rt">
            <span>{{ evt.offensive_player.display_name }}</span>
            <span :class="['icon card', {'red': (evt.event_id == redCard)}, {'yellow': (evt.event_id == yellowCard)}]"></span>
          </div>
        </div>
        <div
          v-else-if="isCard(evt.event_id) && !isAwayTeamEvent(evt.team_id)"
          class="event-strip team_a_event"
        >
          <div class="player player-lt">
            <span>{{ evt.offensive_player.display_name }}</span>
            <span :class="['icon card', {'red': (evt.event_id == redCard)}, {'yellow': (evt.event_id == yellowCard)}]"></span>
          </div>
          <div class="score">
            <span>{{ getMinuteBubble(evt.time) }}</span>
          </div>
          <div class="player player-rt" />
        </div>

        <!-- half time / full time / after extra time -->
        <div
          v-if="isGameBreak(evt.event_id, evt.status_id)"
          :class="['time-img', {'half': ishalfTime(evt.status_id)}]"
        >
          <div class="circle left"></div>
          <div class="circle right" v-if="ishalfTime(evt.status_id)"></div>
          <span class="text">{{breakName[evt.status_id]}}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="fg-box football-details" v-else>
    <div class="table-responsive table-scoreboard points-table">
      <table class="table squad">
        <thead>
          <tr>
            <th class="text-center">{{h_team.name}}</th>
            <th class="text-center">{{a_team.name}}</th>
          </tr>
        </thead>
        <tbody v-if="squads && squads.length">
          <tr
            v-for="(tr, tr_idx) in squads"
            :key="tr_idx"
          >
            <td class="text-center">{{tr.t1}}</td>
            <td class="text-center">{{tr.t2}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["details", "current_match"],
  data() {
    return {
      htStatusIds: [5, 6, 12],
      halfTime: [11],
      goalEvents: [9, 16, 17],
      subsEvents: [13],
      cardEvents: [12, 18],
      yellowCard: 12,
      redCard: 18,
      ownGoal: 16,
      penaltyGoal: 17,
      breakName: {
        "12": "AET", // After Extra time
        "6": "FT", // Full Half
        "5": "HT", // Half Time
      }
    };
  },
  computed: {
    teamsObj() {
      let teams = {};
      let homeTeam = this.teams.find((t) => t.is_home_team);
      if (homeTeam) {
        teams.home_team = homeTeam;
        teams.away_team = this.teams.find((t) => homeTeam.id !== t.id);
      } else {
        teams.home_team = this.teams[0];
        teams.away_team = this.teams[1];
      }
      return teams;
    },
    h_team() {
      return this.teamsObj.home_team;
    },
    a_team() {
      return this.teamsObj.away_team;
    },
    matchTime() {
      return "full-time"; //todo
    },
    events() {
      if(this.details && this.details.eventList && this.details.eventList.length) {
        return this.details.eventList;
      } else {
        return [];
      }
    },
    allGoals() {
      return this.events.filter(et => this.isGoal(et.event_id));
    },
    teams() {
      if(this.details && this.details.teamList && this.details.teamList.length) {
        return this.details.teamList;
      } else {
        return [];
      }
    },
    squads() {
      let teams = this.teams;
      let squad = [];
      if(teams && teams.length) {
        let teamArr = [this.h_team.id, this.a_team.id];
        teamArr.forEach((t, t_idx) => {
          let team = teams.find(tm => t == tm.id);
          if(team) {
            let keyName = (t_idx == 0) ? 't1' : 't2';
            let {players} = team;
            if(players && players.length) {
              players.forEach((p, p_idx) => {
                if(!squad[p_idx]) { squad.push({}); } // new entry
                squad[p_idx][keyName] = this.getDisplayPlayerName(p, true); // update existing entry
              })
            }
          }
        });
      }
      return squad;
    }
  },
  methods: {
    getMinuteBubble(time, showSymbol) {
      if (time) {
        let { minutes, additional_minutes } = time;
        let minSymbol = showSymbol ? `'` : '';
        if (additional_minutes) {
          return `${minutes}${minSymbol} + ${additional_minutes}`;
        } else {
          return `${minutes}${minSymbol}`;
        }
      } else {
        return "";
      }
    },
    isAwayTeamEvent(team_id) {
      return !(team_id == this.h_team.id || team_id == null);
    },
    isGoal(event_id) {
      return !!this.goalEvents.includes(event_id);
    },
    isSubstitute(event_id) {
      return !!this.subsEvents.includes(event_id);
    },
    isCard(event_id) {
      return !!this.cardEvents.includes(event_id);
    },
    isGameBreak(event_id, status_id) {
      return !!(this.halfTime.includes(event_id) && this.htStatusIds.includes(status_id));
    },
    ishalfTime(status_id) {
      return (status_id == 5);
    },
    matchGoals(isRight) {
      if(this.events && this.events.length) {
        if(isRight) {
          let rightGoals = this.allGoals.filter(et => this.isAwayTeamEvent(et.team_id));
          return this.getGoalScorers(rightGoals);
        } else {
          let leftGoals = this.allGoals.filter(et => !this.isAwayTeamEvent(et.team_id));
          return this.getGoalScorers(leftGoals);
        }
      } else {
        return [];
      }
    },
    getGoalScorers(goals) {
      let goalEvents = [];
      let playerIds = [];
      goals.map(et => {
        let goalScorer = `${this.getMinuteBubble(et.time, true)}${this.getRemark(et.event_id)}`;
        let oldPlayer = goalEvents.find(p => p.player_id === et.offensive_player.player_id);
        if(oldPlayer) {
          oldPlayer.goal_details = oldPlayer.goal_details + ", " + goalScorer;
        } else {
          goalEvents.push({
            event_id: et.event_id,
            player_id: et.offensive_player.player_id,
            display_name: et.offensive_player.display_name,
            goal_details: goalScorer
          });
        }
        playerIds.push(et.offensive_player.player_id);
      });
      return goalEvents;
    },
    getRemark(event_id) {
      if(event_id == this.ownGoal) {
        return ' (og)';
      } else if(event_id == this.penaltyGoal) {
        return ' (pen)';
      } else {
        return '';
      }
    },
    getDisplayPlayerName(player, withBadge) {
      let badge = "";
      if (withBadge) {
        if (player["is_captain"] && player["is_goalkeeper"]) {
          badge = " (c & gk)";
        } else if (player["is_captain"]) {
          badge = " (c)";
        } else if (player["is_goalkeeper"]) {
          badge = " (gk)";
        }
      }
      return `${player["display_name"]}${badge}`;
    },
  },
};
</script>